import "./src/style/global.css"
import React from "react"
import { motion, AnimatePresence } from "framer-motion"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import PageLoader from "./src/components/pageLoader"

/* A14: the route transition must not hide article content. The page is painted
   at full opacity straight away; the fade is short enough to read as immediate.
   mode="wait" forced the outgoing page to fully unmount (taking Header,
   Footer, CookieConsent and AnimatedCursor with it, since every page wraps
   itself in <Layout>) before the incoming one mounted, producing a visible
   blank frame on every navigation. Dropping it lets the new page mount
   immediately alongside the outgoing one's removal. */
export const wrapPageElement = ({ element, props }) => (
  <AnimatePresence>
    <motion.div
      key={props.location.pathname}
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      {/* Remounts alongside the page on every key change, so it covers both
          the first load and every subsequent route change uniformly. */}
      <PageLoader />
      {element}
    </motion.div>
  </AnimatePresence>
)
